module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-03.7b57ca40.png";